/********************************************************************** // @@@ START
COPYRIGHT @@@ // AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY // Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd. // Protected as an unpublished work. // The computer program
listings, specifications and documentation // herein are the property of Avi Solar Energy
Pvt Ltd., or a third party supplier // and shall not be reproduced, copied, disclosed, or
used in whole or in part for // any reason without the prior express written permission of
Avi Solar Energy Pvt Ltd. // @@@ END COPYRIGHT @@@ // +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout row wrap>
    <v-dialog v-model="showMap" width="700">
      <MapComponent v-if="showMap" @close="closeMapHandler" :isDark="isDark" />
    </v-dialog>
    <v-flex xs12>
      <HeaderComponent />
    </v-flex>
    <v-flex xs12>
      <DataTableComponent
        :theme="isDark"
        @isMapShownStatus="isMapShownStatus"
        :isMapShown="showMap"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGettersMixin } from "@/util/mixin/index";
import HeaderComponent from "../components/home/HeaderComponent";
import MapComponent from "../components/home/MapComponent";
import DataTableComponent from "../components/home/DataTableComponent";
import { mapGetters } from "vuex";

export default {
  mixins: [mapGettersMixin],
  components: {
    HeaderComponent,
    MapComponent,
    DataTableComponent,
  },
  data() {
    return {
      showMap: false,
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId"]),
  },
  methods: {
    isMapShownStatus(val) {
      this.showMap = val;
    },
    closeMapHandler() {
      this.showMap = false;
    },
  },
};
</script>

<style>
blink,
.blink {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .home-cards {
    max-width: 50% !important;
    flex-basis: 50% !important;
  }

  .home {
    font-size: 20px !important;
  }
}

@media only screen and (min-width: 993px) and (max-width: 1215px) {
  .home {
    font-size: 25px !important;
    word-break: break-word;
    height: 60px;
    line-height: 1;
  }
}

@media only screen and (min-width: 320px) and (max-width: 960px) {
  .home {
    font-size: 15px !important;
    height: 37px;
    word-break: break-all;
    line-height: 1.2;
  }

  .home .card-unit {
    font-size: 15px !important;
  }

  .container.grid-list-xl .layout .flex {
    padding: 12px 6px;
  }

  .home-cards {
    padding-bottom: 0px !important;
    z-index: 0 !important;
  }

  .ag-home {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 48px !important;
  }

  .ag-home .v-toolbar__content {
    padding: 0 10px !important;
  }

  .ag-home-input {
    width: 100px !important;
  }

  .ag-home-refresh {
    width: 30px;
  }

  .ag-info {
    text-align: center;
  }

  .ag-info-name {
    font-size: 13px !important;
  }

  .ag-tab {
    padding: 0 12px !important;
  }
}

.mapDialog {
  background-color: var(--v-primary-base) !important;
  border: 2px solid rgba(83, 122, 228, 0.418);
}

</style>
